import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { getMessage } from '../../messaging/MESSAGE';
import { isSafariOrIos } from '../../utils/deviceUtils';
import { BlobWrapper } from './Blob.styles';
import { BlobImage } from './BlobImage';
import { DecorativeBlobs } from './DecorativeBlobs';
import { InnerSvg } from './InnerSvg';
import { OuterSvg } from './OuterSvg';
import { BlobVideo } from './BlobVideo';
export const Blobs = ({
  colorTheme,
  renderBleed = () => {},
  children,
  messageKey,
  onImageLoaded = () => {},
  isVideo = false
}) => {
  const {
    blobBleed,
    shouldShowDecorativeBlob,
    blobWrapperStyle = {},
    isCard
  } = getMessage(messageKey);
  const [imageLoaded, setImageLoaded] = useState(false);
  const {
    innerBlobColor,
    outerBlobColor
  } = colorTheme;
  useEffect(() => {
    onImageLoaded();
    setImageLoaded(true);
  }, [onImageLoaded]);
  return /*#__PURE__*/_jsxs(BlobWrapper, {
    className: "BlobWrapper",
    "data-message": messageKey,
    imageLoaded: imageLoaded,
    style: blobWrapperStyle,
    children: [/*#__PURE__*/_jsx(OuterSvg, {
      color: outerBlobColor,
      messageKey: messageKey,
      children: /*#__PURE__*/_jsxs(InnerSvg, {
        color: innerBlobColor,
        messageKey: messageKey,
        children: [isVideo && !isSafariOrIos() ? /*#__PURE__*/_jsx(BlobVideo, {
          messageKey: messageKey,
          children: children
        }) : /*#__PURE__*/_jsx(BlobImage, {
          messageKey: messageKey,
          shouldClip: !isCard,
          children: children
        }), blobBleed && !isSafariOrIos() && /*#__PURE__*/_jsx(BlobImage, {
          messageKey: messageKey,
          shouldClip: false,
          children: renderBleed()
        })]
      })
    }), shouldShowDecorativeBlob && /*#__PURE__*/_jsx(DecorativeBlobs, {
      colorTheme: colorTheme
    })]
  });
};